import {
    ListTable,
    LTHeader,
    LTItem,
    LTRow,
    LTMobileItem,
    LTPlaceholder,
} from 'components/common/ListTable';
import { ReactComponent as CheckIcon } from 'assets/icons/check.svg';
import { ReactComponent as HourglassIcon } from 'assets/icons/processing.svg';
import { CurrencySymbol } from 'data/constants/currencySymbol';
import { MilestoneApp } from 'api';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

type Props = {
    milestones: MilestoneApp[];
    isAgreementSigned: boolean;
};

const MilestonesListWithPayment = ({ milestones, isAgreementSigned }: Props) => {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();
    const getIcon = (status: 'PAID' | 'NEW') => {
        if (status === 'PAID') {
            return <CheckIcon fill="#00CB14" />;
        }
        return <HourglassIcon fill="#4A52BB" />;
    };

    return (
        <ListTable>
            <LTHeader>
                <LTItem maxWidth="30%" minWidth="none">
                    {t('milestone', { lng: language })}
                </LTItem>
                <LTItem maxWidth="48%" minWidth="none" style={{ whiteSpace: 'pre-wrap' }}>
                    {t('explanation', { lng: language })}
                </LTItem>
                {isAgreementSigned && (
                    <LTItem maxWidth="38px">{t('paid', { lng: language })}</LTItem>
                )}
                <LTItem maxWidth="60px">{t('price', { lng: language })}</LTItem>
            </LTHeader>
            {milestones.length === 0 && (
                <LTPlaceholder>{t('theListIsEmpty', { lng: language })}</LTPlaceholder>
            )}
            {milestones.map((milestone) => (
                <LTRow key={milestone.id}>
                    {/*FULL SCREEN VERSION*/}
                    <LTItem maxWidth="30%" minWidth="none">
                        {milestone.name}
                    </LTItem>
                    <LTItem maxWidth="48%" minWidth="none" style={{ whiteSpace: 'pre-wrap' }}>
                        {milestone.description}
                    </LTItem>
                    {isAgreementSigned && (
                        <LTItem maxWidth="38px">
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                {getIcon(milestone.status as 'PAID' | 'NEW')}
                            </div>
                        </LTItem>
                    )}
                    <LTItem maxWidth="60px">
                        {CurrencySymbol[milestone.currency as keyof typeof CurrencySymbol]}
                        {milestone.price}
                    </LTItem>

                    {/*SMALL SCREEN VERSION*/}
                    <LTMobileItem name={t('name', { lng: language })}>
                        {milestone.name}
                    </LTMobileItem>
                    <LTMobileItem name={t('explanation', { lng: language })}>
                        {milestone.description}
                    </LTMobileItem>
                    {isAgreementSigned && (
                        <LTMobileItem name={t('paid', { lng: language })}>
                            {getIcon(milestone.status as 'PAID' | 'NEW')}
                        </LTMobileItem>
                    )}
                    <LTMobileItem name={t('price', { lng: language })}>
                        {CurrencySymbol[milestone.currency as keyof typeof CurrencySymbol]}
                        {milestone.price}0
                    </LTMobileItem>
                </LTRow>
            ))}
        </ListTable>
    );
};

export default MilestonesListWithPayment;
